import React from "react";
import { Link } from "react-router-dom";
import "../styles/Home.css";

function Home() {
  return (
    <div>

      {/* HERO */}
      <section className="hero">
        <div className="hero-content">
          <h1 className="fade-up">
            Engineering Excellence <br />
            With Innovation & Precision
          </h1>

          <p className="fade-up delay1">
            BMV Engineers provides reliable mechanical and civil engineering
            solutions including QA/QC, safety services, CNC machining and
            advanced manufacturing technologies.
          </p>

          <div className="hero-buttons fade-up delay2">
            <Link to="/services">
              <button className="primary-btn">Our Services</button>
            </Link>
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section className="services-preview">
        <h2 className="fade-up">Our Core Services</h2>

        <p className="services-subtitle fade-up delay1">
          Delivering precision-driven engineering solutions across multiple domains.
        </p>

        <div className="services-preview-grid">

          <div className="service-box fade-up delay2">
            <span className="material-symbols-outlined">precision_manufacturing</span>
            <h3>Mechanical QA/QC</h3>
            <p>Precision inspection ensuring mechanical reliability.</p>
          </div>

          <div className="service-box fade-up delay3">
            <span className="material-symbols-outlined">foundation</span>
            <h3>Civil QA/QC</h3>
            <p>Structural validation with strict engineering standards.</p>
          </div>

          <div className="service-box fade-up delay4">
            <span className="material-symbols-outlined">shield</span>
            <h3>Safety Services</h3>
            <p>Workplace safety solutions with compliance.</p>
          </div>

          <div className="service-box fade-up delay4">
            <span className="material-symbols-outlined">precision_manufacturing</span>
            <h3>CNC Machining</h3>
            <p>High-precision manufacturing using CNC systems.</p>
          </div>

        </div>

        <Link to="/services">
          <button className="view-more-btn fade-up delay4">
            View All Services →
          </button>
        </Link>
      </section>

      {/* WHY CHOOSE */}
      <section className="why-us">

        <h2 className="fade-up">Why Choose BMV Engineers</h2>

        <div className="why-grid">

          <div className="why-card fade-up delay1">
            <div className="why-icon">
              <span className="material-symbols-outlined">verified</span>
            </div>
            <h3>Quality Assurance</h3>
            <p>Strict QA/QC standards ensuring precision and reliability.</p>
          </div>

          <div className="why-card fade-up delay2">
            <div className="why-icon">
              <span className="material-symbols-outlined">engineering</span>
            </div>
            <h3>Expert Engineers</h3>
            <p>Highly skilled professionals delivering efficient solutions.</p>
          </div>

          <div className="why-card fade-up delay3">
            <div className="why-icon">
              <span className="material-symbols-outlined">precision_manufacturing</span>
            </div>
            <h3>Advanced Technology</h3>
            <p>Utilizing CNC machining and modern engineering tools.</p>
          </div>

          <div className="why-card fade-up delay4">
            <div className="why-icon">
              <span className="material-symbols-outlined">workspace_premium</span>
            </div>
            <h3>Industry Standards</h3>
            <p>Compliant with global engineering and safety standards.</p>
          </div>

        </div>

      </section>

      {/* INDUSTRIES */}
      <section className="industries">

        <h2 className="fade-up">Industries We Serve</h2>

        <div className="industry-grid">

          <div className="industry-card fade-up delay1">
            <h3>Construction</h3>
          </div>

          <div className="industry-card fade-up delay2">
            <h3>Manufacturing</h3>
          </div>

          <div className="industry-card fade-up delay3">
            <h3>Infrastructure</h3>
          </div>

          <div className="industry-card fade-up delay4">
            <h3>Industrial Plants</h3>
          </div>

        </div>

      </section>

      {/* CTA */}
      <section className="cta">
        <h2>Ready to Start Your Project?</h2>

        <p>
          Contact BMV Engineers today to discuss your engineering requirements.
        </p>

        <a
          href="https://wa.me/919074450935?text=Hello%20BMV%20Engineers"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="cta-btn">Contact Us</button>
        </a>
      </section>

    </div>
  );
}

export default Home;